import { render, staticRenderFns } from "./successMediation.vue?vue&type=template&id=86b6c16a&scoped=true"
import script from "./successMediation.vue?vue&type=script&lang=js"
export * from "./successMediation.vue?vue&type=script&lang=js"
import style0 from "./successMediation.vue?vue&type=style&index=0&id=86b6c16a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b6c16a",
  null
  
)

export default component.exports